// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3G5Gh","subheader":"ReorderModal_subheader__W5d9S","listWrap":"ReorderModal_listWrap__2b4lV"};